import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { TopicService } from '../topic.service';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { NumberCardsService } from '../number-cards.service';
import { TSuperExerciseComponent } from '../t-super-exercise/t-super-exercise.component';

@Component({
  selector: 'app-t-add-card-representation',
  templateUrl: './t-add-card-representation.component.html',
  styleUrls: ['./t-add-card-representation.component.css']
})
export class TAddCardRepresentationComponent extends TSuperExerciseComponent {

  cards: number[] = [];
  private count: number[] = [];
  private countB: number[] = [];
  private givenNumbers: number[] = [];
  operation: string = "addition";
  private length: number = 3;

  constructor(protected activatedRoute: ActivatedRoute, protected numberCardsService: NumberCardsService, protected topicService: TopicService, protected _location: Location) {
    super(activatedRoute, numberCardsService, topicService);
    this.type = "cardRepresentationAddition";
    this.title = this.get("cardRepresentationAddition");
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.givenNumbers = this.configuration.typespecifics.givenNumbers;
    let isMultiplication = this.configuration.typespecifics.isMultiplication;
    if (isMultiplication) {
      this.operation = "multiplication";
      this.length = this.givenNumbers.length;
    } else {
      this.operation = "addition";
    }
    this.onChangeRepr();
  }

  /** sets the counts correctly  */
  onChangeGivenNumbers() {
    if (this.representationDefined()) {
      let solution = this.numberCardsService.getSolution(this.givenNumbers[0], this.cards);
      let index = 0;
      for (let card of this.cards) {
        this.count[card] = solution[index];
        index++;
      }
      if (this.operation == "addition") {
        solution = this.numberCardsService.getSolution(this.givenNumbers[1], this.cards);
        index = 0;
        for (let card of this.cards) {
          this.countB[card] = solution[index];
          index++;
        }
      } else {
        this.givenNumbers = new Array(this.length).fill(this.givenNumbers[0]);
      }
    }
  }

  /** computes and sets the cards */
  onChangeRepr() {
    super.onChangeRepr();
    this.onChangeGivenNumbers();
  }

  /** resets all the variables */
  reset() {
    super.reset();
    this.title = this.get("cardRepresentationAddition");
    this.givenNumbers = [];
    this.cards = [];
    this.count = [];
  }

  /** generate the exercise automatically */
  generate() {
    super.generate();
    let operationID = Math.floor(Math.random() * 2);
    switch (operationID) {
      case 0:
        this.operation = "addition";
        this.givenNumbers[0] = Math.floor(Math.random() * this.maxNumber()/2);
        this.givenNumbers[1] = Math.floor(Math.random() * this.maxNumber()/2);
     
        break;
      case 1:
        this.operation = "multiplication";
        this.length = Math.floor(Math.random() * 4) + 2;
        this.givenNumbers[0] = Math.ceil(Math.random() * this.maxNumber() / this.length);
      
    }
    this.title = this.get("cardRepresentationAddition");
    this.onChangeRepr();
    this.onChangeGivenNumbers();
  }

  /** generate the exercise definition */
  generateDefinition(): any {
    let definition = super.generateDefinition();
    definition.image = "./assets/images/dataRepresentationAdd.png";
    definition.key = "dataRepresentation%cardRepresentationAddition%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.representation, "%", this.representationSpec.toString().replace(new RegExp(" ", 'g'), ""), "%", this.givenNumbers.toString())
    definition.typespecifics.isMultiplication = (this.operation == "multiplication");
    definition.typespecifics.givenNumbers = this.givenNumbers;
    definition.typespecifics.showHelp = this.helptext;
    definition.level = 2;
    return definition;
  }
}
